import _remove from 'lodash/remove';
/**
 * @desc  SchedulePointService class.
 * @ngInject
 */
export default class SchedulePointService {
  /**
   * Constructor of the class.
   *
   * @param {$rootScope} $rootScope
   * @param {$q} $q
   * @param {$log}  $log
   * @param {$http} $http
   */
  constructor(
    $rootScope, $q, $log, $http
  ) {
    this.$rootScope = $rootScope;
    this.$q = $q;
    this.$log = $log;
    this.$http = $http;

    this.schedulePoints = [];

    this.$rootScope.$on('scr.select', () => {
      this.schedulePoints.splice(0, this.schedulePoints.length);
    });
  }

  add(schedulePoint) {
    return this.$http({
      method: 'POST',
      url: `/SCR/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}/schedulePoints`,
      data: {schedulePoint}
    }).then(result => result, err => this.$q.reject(err));
  }

  getAll(fromServer = false) {
    if (this.schedulePoints.length > 0 && !fromServer) {
      return this.$q.resolve(this.schedulePoints);
    }

    return this.$http({
      method: 'GET',
      url: `/SCR/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}/schedulePoints`
    }).then(result => {
      this.schedulePoints = result.data.schedulePoints;
      return this.schedulePoints;
    }, err => this.$q.reject(err));
  }

  delete(schedulePointId) {
    return this.$http({
      method: 'DELETE',
      url: `/SCR/schoolCommonRoom/${this.$rootScope.me.schoolCommonRoomId}/schedulePoints/${schedulePointId}`
    }).then(() => {
      _remove(this.schedulePoints, item => item.id === schedulePointId);
    }, err => this.$q.reject(err));
  }
}
